<section
  class="admin-reviews-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="admin-page-head">
    <div>
      <span class="admin-badge">إدارة التقييمات</span>
      <h1>كل التقييمات</h1>
      <p>تحكم في حالة التقييمات، عدّل المحتوى، أو احذف التقييمات.</p>
    </div>

    <button type="button" class="admin-refresh-btn" (click)="loadReviews(page)">
      تحديث
    </button>
  </div>

  <div class="admin-filters-card">
    <div class="filter-group">
      <label>بحث</label>
      <input
        type="text"
        placeholder="ابحث بالاسم أو نص التقييم..."
        [value]="searchKeyword"
        (input)="onSearchInput($event)"
        (keyup.enter)="loadReviews(1)"
      />
    </div>

    <div class="filter-group">
      <label>الحالة</label>
      <select [value]="statusFilter" (change)="onStatusFilterChange($event)">
        <option value="">كل الحالات</option>
        <option value="active">نشط</option>
        <option value="inactive">غير نشط</option>
        <option value="pending">قيد المراجعة</option>
      </select>
    </div>

    <div class="filter-group">
      <label>نوع المستخدم</label>
      <select [value]="userTypeFilter" (change)="onUserTypeFilterChange($event)">
        <option value="">كل الأنواع</option>
        <option value="candidate">مرشح</option>
        <option value="company">شركة</option>
        <option value="admin">مدير</option>
        <option value="guest">زائر</option>
      </select>
    </div>

    <div class="filter-actions">
      <button type="button" class="primary-btn" (click)="loadReviews(1)">
        بحث
      </button>

      <button type="button" class="secondary-btn" (click)="resetFilters()">
        إعادة ضبط
      </button>
    </div>
  </div>

  <div class="admin-table-card">
    <div class="table-top">
      <div>
        <h2>قائمة التقييمات</h2>
        <p>الإجمالي: {{ total }}</p>
      </div>
    </div>

    <div class="admin-state" *ngIf="isLoading">
      جاري تحميل التقييمات...
    </div>

    <div class="admin-state error" *ngIf="!isLoading && errorMessage">
      {{ errorMessage }}
    </div>

    <div
      class="admin-state empty"
      *ngIf="!isLoading && !errorMessage && reviews.length === 0"
    >
      لا توجد تقييمات.
    </div>

    <div
      class="table-responsive"
      *ngIf="!isLoading && !errorMessage && reviews.length > 0"
    >
      <table class="admin-table">
        <thead>
          <tr>
            <th>صاحب التقييم</th>
            <th>التقييم</th>
            <th>النجوم</th>
            <th>نوع المستخدم</th>
            <th>الحالة</th>
            <th>مميز</th>
            <th>التاريخ</th>
            <th class="actions-th">الإجراءات</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let review of reviews; trackBy: trackByReview">
            <td>
              <div class="reviewer-cell">
                <div class="reviewer-avatar" [class.has-image]="review.imageUrl">
                  <img
                    *ngIf="review.imageUrl"
                    [src]="review.imageUrl"
                    [alt]="displayName(review)"
                    loading="lazy"
                    (error)="onAvatarImageError(review)"
                  />

                  <span *ngIf="!review.imageUrl">
                    {{ getAvatarLetter(displayName(review)) }}
                  </span>
                </div>

                <div>
                  <strong>{{ displayName(review) }}</strong>
                  <small>رقم: {{ review.id }}</small>
                </div>
              </div>
            </td>

            <td>
              <p class="review-preview">
                {{ displayText(review) }}
              </p>
            </td>

            <td>
              <div class="stars">
                <span
                  *ngFor="let star of starItems"
                  [class.empty]="star > review.rating"
                >
                  ★
                </span>
              </div>
            </td>

            <td>
              <span class="type-badge">
                {{
                  review.userType === 'candidate'
                    ? 'مرشح'
                    : review.userType === 'company'
                    ? 'شركة'
                    : review.userType === 'admin'
                    ? 'مدير'
                    : review.userType === 'guest'
                    ? 'زائر'
                    : '-'
                }}
              </span>
            </td>

            <td>
              <select
                class="status-select"
                [class.active]="review.status === 'active'"
                [class.inactive]="review.status === 'inactive'"
                [class.pending]="review.status === 'pending'"
                [value]="review.status"
                [disabled]="isChangingStatusId === review.id"
                (change)="changeStatus(review, $event)"
              >
                <option value="active">نشط</option>
                <option value="inactive">غير نشط</option>
                <option value="pending">قيد المراجعة</option>
              </select>
            </td>

            <td>
              <button
                type="button"
                class="featured-btn"
                [class.active]="review.featured"
                [disabled]="isChangingStatusId === review.id"
                (click)="toggleFeatured(review)"
              >
                {{ review.featured ? 'نعم' : 'لا' }}
              </button>
            </td>

            <td>
              {{ formatDate(review.createdAt) }}
            </td>

            <td>
              <div class="table-actions">
                <button type="button" class="edit-btn" (click)="openEditModal(review)">
                  تعديل
                </button>

                <button
                  type="button"
                  class="delete-btn"
                  [disabled]="isDeletingId === review.id"
                  (click)="deleteReview(review)"
                >
                  {{ isDeletingId === review.id ? 'جاري الحذف...' : 'حذف' }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="pagination"
      *ngIf="!isLoading && !errorMessage && reviews.length > 0 && lastPage > 1"
    >
      <button
        type="button"
        [disabled]="page <= 1"
        (click)="loadReviews(page - 1)"
      >
        السابق
      </button>

      <button
        type="button"
        *ngFor="let item of pages"
        [class.active]="page === item"
        (click)="loadReviews(item)"
      >
        {{ item }}
      </button>

      <button
        type="button"
        [disabled]="page >= lastPage"
        (click)="loadReviews(page + 1)"
      >
        التالي
      </button>
    </div>
  </div>
</section>

<div class="admin-modal-backdrop" *ngIf="showEditModal">
  <div class="admin-modal" [class.is-rtl]="isAr" [attr.dir]="isAr ? 'rtl' : 'ltr'">
    <div class="modal-head">
      <div>
        <h2>تعديل التقييم</h2>
        <p>عدّل بيانات التقييم ثم احفظ التغييرات.</p>
      </div>

      <button type="button" class="modal-close" (click)="closeEditModal()">
        ×
      </button>
    </div>

    <form [formGroup]="reviewForm" (ngSubmit)="submitEdit()">
      <div class="modal-grid">
        <label>
          <span>الاسم بالإنجليزي</span>
          <input type="text" formControlName="name_en" />
        </label>

        <label>
          <span>الاسم بالعربي</span>
          <input type="text" formControlName="name_ar" />
        </label>

        <label>
          <span>عدد النجوم</span>
          <input type="number" min="1" max="5" formControlName="rating" />
        </label>

        <label>
          <span>الحالة</span>
          <select formControlName="status">
            <option value="active">نشط</option>
            <option value="inactive">غير نشط</option>
            <option value="pending">قيد المراجعة</option>
          </select>
        </label>

        <label>
          <span>نوع المستخدم</span>
          <select formControlName="user_type">
            <option value="candidate">مرشح</option>
            <option value="company">شركة</option>
            <option value="admin">مدير</option>
            <option value="guest">زائر</option>
          </select>
        </label>

        <label class="checkbox-label">
          <input type="checkbox" formControlName="featured" />
          <span>تقييم مميز</span>
        </label>

        <label class="full">
          <span>نص التقييم بالإنجليزي</span>
          <textarea rows="4" formControlName="text_en"></textarea>
        </label>

        <label class="full">
          <span>نص التقييم بالعربي</span>
          <textarea rows="4" formControlName="text_ar"></textarea>
        </label>
      </div>

      <div class="modal-actions">
        <button type="button" class="secondary-btn" (click)="closeEditModal()">
          إلغاء
        </button>

        <button type="submit" class="primary-btn" [disabled]="isSaving">
          {{ isSaving ? 'جاري الحفظ...' : 'حفظ التغييرات' }}
        </button>
      </div>
    </form>
  </div>
</div>